//@flow
import React from 'react';
import StackedBar from '../StackedBar/StackedBar';
import ExtraBar from '../ExtraBar/ExtraBar';
import s from './StackedBarWaterfall.less';
import * as pick from 'lodash.pick';

const StackedBarWaterfall = ({
  totalFobTooling,
  totalFobwithoutTooling,
  summaryData,
  otherAdjustmentCost,
}) => {
  return (
    <div className={`${s.waterfallWrapper}`}>
      <StackedBar
        totalFobTooling={totalFobTooling}
        totalFobwithoutTooling={totalFobwithoutTooling}
        data={pick (summaryData, [
          'Material Cost',
          'Labor Cost',
          'Overhead Cost',
          'Profit Cost',
        ])}
        otherAdjustmentCost={otherAdjustmentCost}
      />
      <ExtraBar
        totalFobTooling={totalFobTooling}
        totalFobwithoutTooling={totalFobwithoutTooling}
        section={'Other Cost'}
        absoluteSectionCost={Math.abs (
          summaryData['Other Cost'].sectionSummary.cost
        )}
        toolingCost={summaryData['Tooling Cost'].sectionSummary.cost}
        otherAdjustmentCost={
          summaryData['Other Cost'].sectionSummary.cost
        }
      />
      <ExtraBar
        totalFobTooling={totalFobTooling}
        totalFobwithoutTooling={totalFobwithoutTooling}
        section={'Tooling Cost'}
        absoluteSectionCost={summaryData['Tooling Cost'].sectionSummary.cost}
        toolingCost={summaryData['Tooling Cost'].sectionSummary.cost}
        otherAdjustmentCost={
          summaryData['Other Cost'].sectionSummary.cost
        }
      />
    </div>
  );
};

export default StackedBarWaterfall;



// WEBPACK FOOTER //
// ./src/components/StackedBarChart/StackedBarWaterfall/StackedBarWaterfall.js